// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const krabby: PokeData = {
  "id": 98,
  "name": "krabby",
  "height": 4,
  "weight": 65,
  "base_experience": 65,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "swords-dance",
    "slam",
    "stomp",
    "leer",
    "water-gun",
    "bubble-beam",
    "harden",
    "bubble",
    "crabhammer",
    "flail",
    "protect",
    "metal-claw",
    "mud-sport",
    "mud-shot",
    "brine",
    "razor-shell"
  ],
  "moves": [
    "leer",
    "bubble-beam",
    "bubble",
    "protect",
    "metal-claw",
    "mud-shot",
    "brine",
    "whirlpool",
    "aqua-cutter",
    "life-dew",
    "rain-dance",
    "water-spout",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 43,
    "item": null,
    "species": [
      {
        "name": "krabby",
        "order": 107,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kingler",
        "order": 108,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 98,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 43.75,
    "speed": 50,
    "ability_power": 105
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
